import { useMutation, useQueryClient } from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { statementItemRepository } from '@webapp/modules/accounts-payable/data-access/repositories/StatementItemRepository'
import { STATEMENT_ITEM_UNMATCHED_BASE_KEY } from '@webapp/modules/accounts-payable/query-configs/statementItemQueries'

export const useMutateRemoveStatementItem = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation<void, RepoError, { statementItemId: number }>({
    mutationFn: ({ statementItemId }) =>
      statementItemRepository.delete(statementItemId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: STATEMENT_ITEM_UNMATCHED_BASE_KEY,
      })
    },
  })

  return {
    removeStatementItem: mutation.mutateAsync,
    isRemoving: mutation.isLoading,
    error: mutation.error,
  }
}
